<template>
  <div>
    <div
      ref="contentRef"
      class="prose max-w-none text-base font-normal leading-tight text-gray-800 pt-4 transition-all duration-300"
      :class="isExpanded ? '' : 'line-clamp-5'"
    >
      <slot name="content" />
    </div>
    <button
      v-if="showToggle"
      type="button"
      class="text-sm font-medium text-gray-600 hover:text-gray-900 underline"
      @click="isExpanded = !isExpanded"
    >
      {{ isExpanded ? trans.get('miliboo.common.see-less') : trans.get('miliboo.common.see-more') }}
    </button>
  </div>
</template>

<script setup>
import {
  ref, onMounted, nextTick, inject,
} from 'vue';
import { useResizeObserver } from '@vueuse/core';

const contentRef = ref(null);
const isExpanded = ref(false);
const showToggle = ref(false);
const trans = inject('translate');

const checkOverflow = () => {
  if (!contentRef.value) return;

  const hadClamp = contentRef.value.classList.contains('line-clamp-5');
  if (hadClamp) {
    contentRef.value.classList.remove('line-clamp-5');
  }

  const styles = getComputedStyle(contentRef.value);
  const lineHeight = parseFloat(styles.lineHeight);
  const paddingTop = parseFloat(styles.paddingTop);
  const paddingBottom = parseFloat(styles.paddingBottom);
  const height = contentRef.value.clientHeight;

  if (hadClamp && !isExpanded.value) {
    contentRef.value.classList.add('line-clamp-5');
  }

  const contentHeight = height - paddingTop - paddingBottom;
  const numberOfLines = Math.ceil(contentHeight / lineHeight);

  showToggle.value = numberOfLines > 5;
};

onMounted(() => {
  nextTick(() => {
    checkOverflow();
  });
});

useResizeObserver(contentRef, checkOverflow);
</script>
